import axios, { AxiosError } from 'axios';
import { ROUTES_PATH } from '../constants';
import history from '../utils/history';
import InsightService from './../services/Insight/index';

interface ErrorResponseData {
  result?: {
    errors?: Array<{
      code?: string;
    }>;
  };
}

export const onResponseError = async (
  error: AxiosError<ErrorResponseData>
): Promise<AxiosError> => {
  const config = error.config;
  InsightService.logException(error);
  if (!error.response?.status) {
    InsightService.logTrace('ResponseError', [
      { code: error.code },
      { config: error.config },
      { status: error.response?.status },
      {
        errorData: !error.message
          ? JSON.stringify(error.toJSON())
          : error.message,
      },
    ]);
  }
  let counter = 0;
  let maxRetries = 0;
  // When there is no error response, the error code is 0
  if (
    (error.response?.status === 500 &&
      !error.request.responseURL.includes('/reuse-payment')) ||
    (error.response?.status === 409 &&
      !error.request.responseURL.includes('/decisions')) ||
    !error.response
  ) {
    if (error.response?.status === 500 || !error.response) {
      maxRetries = 1;
    } else {
      maxRetries = 4;
    }
    while (counter < maxRetries) {
      counter++;
      try {
        const response = await axios.request(config);
        return Promise.resolve(response.data.data);
      } catch (error) {
        if (counter === maxRetries) {
          history.replace(ROUTES_PATH.UNKNOWN_ERROR);
        }
      }
    }
  } else if (error.response?.status === 401) {
    history.replace(ROUTES_PATH.TIMEOUT);
  } else {
    const errorCode = error.response?.data?.result?.errors[0]?.code;
    switch (error.response?.status) {
      case 400:
        if (errorCode === 'ESG0016') {
          history.replace(ROUTES_PATH.UNKNOWN_ERROR, { errorCode: errorCode });
        } else if (
          error.response.config?.url?.includes('enrichment-threatmetrix')
        ) {
          history.replace(history.location.pathname, {});
        } else if (
          errorCode !== 'ESG0014' &&
          errorCode !== 'ESG0015' &&
          !error.response.config?.url?.includes('enrichment-threatmetrix')
        ) {
          history.replace(ROUTES_PATH.UNKNOWN_ERROR);
        } else {
          history.replace(history.location.pathname, { errorCode: errorCode });
        }
        break;
      case 422:
        if (errorCode === 'CRP0006') {
          history.replace(ROUTES_PATH.UNPROCESSABLE);
        } else if (
          errorCode !== 'DRF0013' &&
          errorCode !== 'DRF0027' &&
          errorCode !== 'DRF0078' &&
          errorCode !== 'DRF0079' &&
          errorCode !== 'DRF0080' &&
          errorCode !== 'DRF0081' &&
          errorCode !== 'DRF0089' &&
          errorCode !== 'DRF0092'
        ) {
          history.replace(history.location.pathname, { errorCode: errorCode });
        }
        break;
      case 500:
      case 409:
        break;
      case 404:
        if (
          !error.request.responseURL.includes('/cities') &&
          !error.request.responseURL.includes('/me/commercial-offers')
        ) {
          history.replace(ROUTES_PATH.UNKNOWN_ERROR);
        }
        break;
      default:
        if (error.message !== 'canceled') {
          history.replace(ROUTES_PATH.UNKNOWN_ERROR);
        }
        break;
    }
  }
  return Promise.reject(error);
};
